import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { enableProduct } from '@/data/api/request/productCatalogRequests';
import { stringOrNull } from '@/utils/functions';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useEnableProduct() {
  const queryClient = useQueryClient();
  const { showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: { productId: string; productSku: string }) => {
      await enableProduct(args.productId, args.productSku);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.product.catalog] });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.product.catalogSearch],
      });
    },
    onError: (error) => showSnackError(stringOrNull(error) ?? 'error'),
  });
  return mutation;
}
